import { FormattedMessage } from 'react-intl';

import { TextButton } from '@xing-com/button';
import { sanitizeUrl } from '@xing-com/crate-people-directory-utils';
import { IconArrowRight } from '@xing-com/icons';
import { BodyCopy } from '@xing-com/typography';

import type { PeopleUserBagItemFields } from '../types';

export const UserBagPageLink: React.FC<PeopleUserBagItemFields> = ({
  name,
  count,
  url,
}) => (
  <div>
    <BodyCopy>
      <FormattedMessage
        id="PD_USER_BAG_COMPONENT_DESCRIPTION"
        values={{
          strong: (chunks) => <strong>{chunks}</strong>,
          children_count: count,
          display_name: name,
        }}
      />
    </BodyCopy>
    <TextButton
      size="small"
      icon={IconArrowRight}
      iconAfter
      href={sanitizeUrl(url)}
    >
      <FormattedMessage id="PD_USER_BAG_COMPONENT_BUTTON_LABEL" />
    </TextButton>
  </div>
);
